<ng-container>
  <h3 *ngIf="title">{{ title }}</h3>
  <valg-dk-map
    *ngIf="mapAreasMapping"
    [mapUrl]="mapUrl"
    [width]="width"
    (areaClicked)="areaClicked.emit($event)"
    [mapAreaMapping]="mapAreasMapping"
  >
  </valg-dk-map>
  <valg-dk-map-legend></valg-dk-map-legend>
</ng-container>

